export type LinkTarget = "new-tab" | "same-tab" | "same-frame" | "modal";

export function getAnchorTarget(
  target: LinkTarget,
): "_blank" | "_parent" | "_self" {
  switch (target) {
    default:
    case "new-tab":
      return "_blank";
    case "same-tab":
      // <zapier-zap-manager-iframe-internal> is inside an iframe, so we want to
      // replace the parent frame, not the current frame. If we're not in an
      // iframe, this behaves the same as _self anyway.
      //
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
      return "_parent";
    case "same-frame":
      // In some cases using _parent can take over the whole page rather than the iframe
      // or modal the iframe is in.
      return "_self";
  }
}
